// Mock data for Scraperino Dashboard

export const runInfo = {
  site: 'cultura.com',
  lastRunDuration: '05:09',
  progress: 72,
  pages: { current: 1, max: 4 },
  products: 0,
  eta: '--',
  proxy: '80 Ko',
  incidents: 1,
};

export const activeSite = {
  site: 'cultura.com',
  country: 'hors Europe',
  progress: 25,
};

export const globalStats = {
  productsExtracted: 45,
  proxy30d: '0.01',
  runs: 27,
  csvFiles: 15,
};

export const countriesData = [
  { name: 'Allemagne', count: 12 },
  { name: 'France', count: 8 },
  { name: 'Espagne', count: 6 },
  { name: 'Italie', count: 5 },
  { name: 'Belgique', count: 3 },
  { name: 'Pays-Bas', count: 2 },
];

export const activityData = [
  { run: '#14', pages: 12, produits: 4 },
  { run: '#15', pages: 68, produits: 42 },
  { run: '#16', pages: 45, produits: 40 },
  { run: '#17', pages: 3, produits: 1 },
  { run: '#18', pages: 10, produits: 12 },
  { run: '#19', pages: 22, produits: 3 },
  { run: '#20', pages: 2, produits: 1 },
  { run: '#21', pages: 62, produits: 2 },
  { run: '#22', pages: 63, produits: 62 },
  { run: '#23', pages: 22, produits: 2 },
  { run: '#24', pages: 4, produits: 1 },
  { run: '#25', pages: 3, produits: 1 },
  { run: '#26', pages: 2, produits: 1 },
  { run: '#27', pages: 2, produits: 1 },
];

export const monitorStats = {
  crons: { count: 16, status: 'tous OK' },
  scrapers: { count: 0, status: 'en cours' },
  batch: { success: 5, total: 247, subtext: '18 succès · 12 err' },
  csv: { count: 15, status: 'fichiers' },
};

export const cronsList = [
  { name: 'KAVENDOR — Découverte quotidienne de sites en liquidation', schedule: '0 7 * * *', status: 'ok', last: '2026-09-19T07:06:15', next: '2026-09-20T07:00:00' },
  { name: 'KAVENDOR — Scrape nocturne complet + fusion (script pur 0 to)', schedule: '5 0 * * *', status: 'ok', last: '2026-09-19T00:05:44', next: '2026-09-20T00:05:00' },
  { name: 'KAVENDOR — Debrief quotidien 7h30 Discord', schedule: '30 5 * * *', status: 'ok', last: '2026-09-19T05:32:38', next: '2026-09-20T05:30:00' },
  { name: 'KAVENDOR — Vérification quotidienne des crons', schedule: '15 8 * * *', status: 'ok', last: '2026-09-19T08:16:15', next: '2026-09-20T08:15:00' },
  { name: 'KAVENDOR — Scrape nocturne ProfitPath MOYEN (247 Sitemap)', schedule: '10 0 * * *', status: 'ok', last: '2026-09-19T00:10:42', next: '2026-09-20T00:10:00' },
  { name: 'KAVENDOR — Supervision nuit (DeepSeek si alerte seulement)', schedule: '45 6 * * *', status: 'ok', last: '2026-09-19T06:46:55', next: '2026-09-20T06:45:00' },
  { name: 'KAVENDOR — Agent supervision tous crons', schedule: '5 6 * * *', status: 'ok', last: '2026-09-19T06:06:07', next: '2026-09-20T06:05:00' },
  { name: 'KAVENDOR — 2nde vague scrape (5h)', schedule: '0 3 * * *', status: 'ok', last: '2026-09-19T03:00:47', next: '2026-09-20T03:00:00' },
  { name: 'KAVENDOR — Sync snapshot dashboard (15min)', schedule: '*/15 * * * *', status: 'ok', last: '2026-09-19T13:15:11', next: '2026-09-19T13:45:00' },
  { name: 'KAVENDOR — Prospection + scrap autonome 24h (continu)', schedule: '30 * * * *', status: 'ok', last: '2026-09-19T12:35:21', next: '2026-09-19T14:30:00' },
  { name: 'KAVENDOR — Firecrawl : retest sites anti-bot (agent firecraw)', schedule: '0 6 * * *', status: 'ok', last: '2026-09-19T06:03:36', next: '2026-09-20T06:00:00' },
  { name: 'Scraper hebdo catalogue grossiste ALSO FR', schedule: '30 4 * * 1', status: 'ok', last: '2026-09-14T04:30:43', next: '2026-09-21T04:30:00' },
  { name: 'KAVENDOR — Gardien modèles (alerte si dérapage coûteux)', schedule: '0 * * * *', status: 'ok', last: '2026-09-19T13:00:07', next: '2026-09-19T14:00:00' },
  { name: 'KAVENDOR — Point coût quotidien Discord', schedule: '45 5 * * *', status: 'ok', last: '2026-09-19T05:45:50', next: '2026-09-20T05:45:00' },
  { name: 'KAVENDOR — Fusion par pays à 6h (découplée du nocturne)', schedule: '0 6 * * *', status: 'ok', last: '—', next: '2026-09-20T06:00:00' },
];

export const csvFiles = [
  { name: 'emmetistore-2026-09-19_12-32.it.oa.csv', size: '67 ko' },
  { name: 'filtrer-ufesa-2026-09-19_11-32.es.oa.EN-STOCK.csv', size: '74 ko' },
  { name: 'filtrer-dreams4kids-2026-09-19_11-32.de.oa.EN-STOCK.csv', size: '190 ko' },
  { name: 'dreams4kids-2026-09-19_11-32.de.oa.csv', size: '225 ko' },
  { name: 'ufesa-2026-09-19_11-32.es.oa.csv', size: '121 ko' },
  { name: 'filtrer-giocattolieshop-2026-09-19-1040.it.oa.EN-STOCK.csv', size: '398 ko' },
  { name: 'giocattolieshop-2026-09-19-1040.it.oa.csv', size: '420 ko' },
  { name: 'filtrer-peragashop-2026-09-19-1035.it.oa.EN-STOCK.csv', size: '305 ko' },
  { name: 'peragashop-2026-09-19-1035.it.oa.csv', size: '449 ko' },
  { name: 'filtrer-bricohomeferramenta-2026-09-19-0935.it.oa.EN-STOCK.csv', size: '455 ko' },
  { name: 'bricohomeferramenta-2026-09-19-0935.it.oa.csv', size: '484 ko' },
  { name: 'filtrer-cofan-es-2026-09-19-0835.es.oa.EN-STOCK.csv', size: '146 ko' },
  { name: 'cofan-es-2026-09-19-0835.es.oa.csv', size: '259 ko' },
  { name: 'filtrer-megajuguetes-2026-09-19-0752.es.oa.EN-STOCK.csv', size: '33 ko' },
  { name: 'megajuguetes-2026-09-19-0752.es.oa.csv', size: '460 ko' },
];

export const runsHistory = [
  { id: '#16', site: 'industry-elec…', date: '01/09', color: 'orange' },
  { id: '#17', site: 'conrad.de', date: '01/09', color: 'orange' },
  { id: '#18', site: 'conrad.de', date: '01/09', color: 'orange' },
  { id: '#19', site: 'buyzoxs.de', date: '02/09', color: 'orange' },
  { id: '#20', site: 'books.toscrap…', date: '02/09', color: 'orange' },
  { id: '#21', site: 'buyzoxs.de', date: '02/09', color: 'orange' },
  { id: '#22', site: 'caseking.de', date: '02/09', color: 'cyan' },
  { id: '#23', site: 'cultura.com', date: '03/09', color: 'pink' },
  { id: '#24', site: 'cultura.com', date: '03/09', color: 'orange' },
  { id: '#25', site: 'cultura.com', date: '03/09', color: 'green' },
  { id: '#26', site: 'cultura.com', date: '03/09', color: 'orange' },
  { id: '#27', site: 'cultura.com', date: '03/09', color: 'pink' },
];

// European cities where scraping is happening (for the radar globe)
export const scrapingLocations = [
  { city: 'Paris', country: 'France', lat: 48.8566, lng: 2.3522, x: 51, y: 50, active: false },
  { city: 'Berlin', country: 'Allemagne', lat: 52.52, lng: 13.4050, x: 60, y: 42, active: true },
  { city: 'Madrid', country: 'Espagne', lat: 40.4168, lng: -3.7038, x: 43, y: 60, active: false },
  { city: 'Rome', country: 'Italie', lat: 41.9028, lng: 12.4964, x: 58, y: 60, active: false },
  { city: 'Amsterdam', country: 'Pays-Bas', lat: 52.3676, lng: 4.9041, x: 54, y: 44, active: false },
  { city: 'Bruxelles', country: 'Belgique', lat: 50.8503, lng: 4.3517, x: 53, y: 47, active: false },
  { city: 'Lisbonne', country: 'Portugal', lat: 38.7223, lng: -9.1393, x: 38, y: 63, active: false },
  { city: 'Vienne', country: 'Autriche', lat: 48.2082, lng: 16.3738, x: 62, y: 51, active: false },
];
